// Composer: swap smart punctuation for plain characters as the user types or
// pastes. Text set by code (From name, coupon, reply fills) is caught by the
// counter, which normalizes before counting.
import { normalizeTextarea } from '@/utils/sms-text';

const TEXTAREA = '.js-form-message-body';


function update() {
  // Let the counter and preview pick up the new text
  if (normalizeTextarea(this)) { $(this).trigger('change'); }
}


export function initSmartChars() {
  return $(document)
    .off('input', TEXTAREA, update)
    .on('input', TEXTAREA, update);
}


App.ready(initSmartChars);
